/* eslint-disable import/no-cycle */
import { call, put, takeEvery } from 'redux-saga/effects';
import { displayLoading, displaySuccess } from '../../utils/toast/Toast';
import { stock } from '../../api/api';
import {
  GET_STOCK,
  GET_STOCK_SUCCESS,
  GET_STOCK_FAILURE,
  GET_REQUIRED_ATTRIBUTES,
  GET_REQUIRED_ATTRIBUTES_SUCCESS,
  GET_REQUIRED_ATTRIBUTES_FAILURE,
  GET_PRODUCT,
  GET_PRODUCT_SUCCESS,
  UPDATE_ITEM_SUCCESS,
  UPDATE_ITEM_FAILURE,
  UPDATE_ITEM,
  GET_PRODUCT_FAILURE,
  REPLACE_BUFFER_QUANTITY_SUCCESS,
  REPLACE_BUFFER_QUANTITY_FAILURE,
  REPLACE_BUFFER_QUANTITY
} from './stockActions';

import logger from '../../utils/logger';

/**
 * Récupération de l'ensemble des produits du stock
 */
export function* getStock(action) {
  try {
    const response = yield call(stock.getStock, action.payload);
    yield put({
      type: GET_STOCK_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    logger(error);
    yield put({ type: GET_STOCK_FAILURE });
  }
}

/**
 * Récupération d'un produit
 */
export function* getProduct(action) {
  try {
    const response = yield call(stock.getProduct, action.payload);
    yield put({
      type: GET_PRODUCT_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    logger(error);
    yield put({ type: GET_PRODUCT_FAILURE });
  }
}

/**
 * Récupération des attributs pouvant être scannés
 */
export function* getRequiredAttributes() {
  try {
    const response = yield call(stock.getRequiredAttributes);
    yield put({
      type: GET_REQUIRED_ATTRIBUTES_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    logger(error);
    yield put({ type: GET_REQUIRED_ATTRIBUTES_FAILURE });
  }
}

/**
 * Mise à jour des items d'une commande
 * @param  {Object}    action action object
 */
export function* updateItem(action) {
  const closeLoading = displayLoading(`Mise à jour en cours`);
  try {
    const response = yield call(stock.updateItem, action.payload);
    if (response.data.success === true) {
      if (action.payload.onSuccess) {
        yield call(action.payload.onSuccess);
        return;
      }
      yield put({ type: UPDATE_ITEM_SUCCESS, payload: response.data });
      displaySuccess('Produit mis à jour');
    }
  } catch (error) {
    logger(error);
    yield put({ type: UPDATE_ITEM_FAILURE });
  } finally {
    closeLoading();
  }
}

/**
 * Mise à jour de la quantité buffer pour un produit
 * @param  {Object}    action action object
 */
export function* replaceBufferQuantity(action) {
  const closeLoading = displayLoading(`Mise à jour en cours`);
  try {
    const response = yield call(stock.replaceBufferQuantity, action.payload);
    if (response.data.success === true) {
      yield put({
        type: REPLACE_BUFFER_QUANTITY_SUCCESS,
        payload: response.data
      });
      displaySuccess('Produit mis à jour');
    }
  } catch (error) {
    logger(error);
    yield put({ type: REPLACE_BUFFER_QUANTITY_FAILURE });
  } finally {
    closeLoading();
  }
}

const signinSaga = [
  takeEvery(GET_STOCK, getStock),
  takeEvery(UPDATE_ITEM, updateItem),
  takeEvery(GET_REQUIRED_ATTRIBUTES, getRequiredAttributes),
  takeEvery(GET_PRODUCT, getProduct),
  takeEvery(REPLACE_BUFFER_QUANTITY, replaceBufferQuantity)
];

export default signinSaga;
